import { render, staticRenderFns } from "./live-chat.vue?vue&type=template&id=3ef56f23&scoped=true&"
import script from "./live-chat.vue?vue&type=script&lang=js&"
export * from "./live-chat.vue?vue&type=script&lang=js&"
import style0 from "./live-chat.vue?vue&type=style&index=0&id=3ef56f23&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef56f23",
  null
  
)

export default component.exports